<script setup>
import { defineEmits, defineProps } from 'vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: true,
  },
  buttonLabel: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['create']);

const handleCreate = () => {
  emit('create');
};
</script>

<template>
  <div class="flex flex-col items-center justify-center">
    <div class="flex flex-col items-center max-w-md">
      <div class="mb-4">
        <fluent-icon icon="shopping-bag" size="48" class="text-n-slate-9" />
      </div>
      <h2 class="mb-2 text-lg font-medium text-n-slate-12">
        {{ title }}
      </h2>
      <p class="mb-6 text-center text-n-slate-11">
        {{ subtitle }}
      </p>
      <button
        class="px-4 py-2 text-sm font-medium text-white bg-woot-600 rounded-md hover:bg-woot-700"
        @click="handleCreate"
      >
        {{ buttonLabel }}
      </button>
    </div>
  </div>
</template>
